<template>
  <div class="feedback-container">
    <van-nav-bar :title="content.feedback" left-arrow @click-left="onClickLeft" />
    <div class="feedback-container-p">
      <div class="feedback-form-item-p">
        <div class="feedback-form-item">{{ content.feedbackTitle }}<em class="require">*</em></div>
        <div class="feedback-form-item">
          <van-field v-model="title" rows="2" autosize type="textarea" maxlength="50" :placeholder="content.feedbackTitlePlaceholder" />
        </div>
      </div>
      <div class="feedback-form-item-p">
        <div class="feedback-form-item">{{ content.feedbackContent }}<em class="require">*</em></div>
        <div class="feedback-form-item">
          <van-field
            v-model="desc"
            rows="5"
            type="textarea"
            maxlength="250"
            :placeholder="content.feedbackContentPlaceholder"
            show-word-limit
          />
        </div>
      </div>
      <div class="feedback-form-item-p">
        <div class="feedback-form-item1">
          <div>{{ content.feedbackImages }}</div>
          <div>{{ fileList.length }} / {{ maxCount }}</div>
        </div>
        <div class="feedback-form-item">
          <upload
            :maxNum="maxCount"
            :pictureList="fileList"
            :maxSize="10"
            @success="uploadSuccess"
          ></upload>
        </div>
      </div>
      <div class="feedback-btn-p">
        <van-button type="info" round color="#1EAFFE" class="feedback-btn" @click="submit">{{ content.feedbackSubmit }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 意见反馈页面
 */
import upload from '@/components/upload'
import { postAddFeedBack } from '@/models/common'
export default {
  components: {
    upload
  },
  data() {
    return {
      title: '',
      desc: '',
      fileList: [],
      maxCount: 3,
      memberId: ''
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    }
  },
  mounted(){
    // 若地址不传则先取缓存的，没缓存则默认游客
    if (localStorage.getItem('loginItem')) {
      this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
    } else {
      this.memberId = '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
    }
    this.initWxBtns()
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1)
    },
    // 上传成功
    uploadSuccess(imgList){
      this.fileList = [...imgList]
    },
    // 提交
    submit(){
      const _this = this
      if(this.memberId != '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        if(this.title == ''){
          // 请输入标题
          this.$toast(this.content.feedbackTitlePlaceholder)
          return
        }
        if(this.desc == ''){
          // 请填写详细描述
          this.$toast(this.content.feedbackContentDesc)
          return
        }
        let imgs = this.fileList.map(v=>v.url)
        postAddFeedBack({
          member_id: this.memberId,
          title: this.title,
          content: this.desc,
          images: imgs
        }).then(res=>{
          if(res.data.code == 0) {
            // 提交成功
            this.$toast(this.content.submitSuccess)
            this.resetForm()
            setTimeout(()=>{
              _this.onClickLeft()
            }, 500)
          }else {
            this.$toast(res.data.message)
          }
        })
      } else {
        // 游客模式不允许投诉
        this.$toast(this.content.feedbackFail)
      }
    },
    // 重置表单
    resetForm() {
      this.title = ''
      this.desc = ''
      this.fileList = []
    },
    // 初始化微信按钮
    initWxBtns() {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    }
  }
}
</script>

<style lang="less" scoped>
.feedback-container {
  //   position: relative;
  height: 100%;
  background-color: #f7f8fa;
  /deep/.van-nav-bar {
    background-color: #1EAFFE;
    .van-icon {
      color: #fff;
    }
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .feedback-container-p {
    max-height: calc(100% - 0.61333rem);
    overflow-y: auto;
    .feedback-form-item-p {
      margin-top: 0.2rem;
      padding: 0.21rem 0.21rem 0;
      background-color: #FFF;
    }
    .feedback-form-item {
      font-size: 0.21rem;
      color: #333333;
      padding-bottom: 0.2rem;
      /deep/.van-cell {
        border: 1px solid #f2f2f2;
      }
      .require {
        color: #c63e3a;
        font-style: normal;
        margin-left: 4px;
      }
    }
    .feedback-form-item1 {
      display: flex;
      justify-content: space-between;
      align-content: center;
      margin-bottom: 0.2rem;
      font-size: 0.21rem;
    }
    .feedback-btn-p {
      margin-top: 0.4rem;
      padding-bottom: 0.2rem;
      text-align: center;
      .feedback-btn {
        width: 2.67rem;
        height: 0.5rem;
        //   font-size: 0.24rem;
      }
    }
  }
}
</style>
